'use client';

import { useRouter } from 'next/navigation';

import { Button } from '@/components/ui/button/button';
import { openFormModal } from '@/lib/utils/modal-event';
import { ButtonHTMLAttributes } from 'react';

export type LinkProps = {
  key: string;
  label: string;
  href: string;
  newWindow: boolean;
  variant: 'primary' | 'secondary';
  destination?: 'URL' | 'Page' | 'Form';
  productId?: string;
  ctaId?: string;
  // TypeForm fields
  formId?: number;
  formSlugId?: string;
  badge?: string;
  title?: string;
  description?: string;
  successTitle?: string;
  successDescription?: string;
  successCTA?: {
    label?: string;
    url?: string;
    type?: 'Button' | 'Link';
  };
};

type ProductCtaProps = {
  links: LinkProps[];
  withArrow?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const ProductCtas = ({ links, withArrow = true, ...rest }: ProductCtaProps) => {
  const router = useRouter();

  const openInNewTab = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleLinkNavigation = (url: string, newWindow: boolean) => {
    return newWindow ? openInNewTab(url) : router.push(url);
  };

  return links.map((link) => (
    <Button
      key={link.key}
      variant={link.variant || 'primary'}
      withArrow={withArrow}
      onClick={
        link.destination === 'Form'
          ? () => {
              if (link.formId && link.formSlugId) {
                openFormModal({
                  formId: link.formId,
                  slugId: link.formSlugId,
                  productId: link.productId,
                  ctaId: link.key || undefined,
                  badge: link.badge,
                  title: link.title,
                  description: link.description,
                  successTitle: link.successTitle,
                  successDescription: link.successDescription,
                  successCTA: link.successCTA,
                });
              } else {
                console.warn(
                  `CTA "${link.label}" has destination 'Form' but missing formId/formSlugId`,
                );
              }
            }
          : () => handleLinkNavigation(link.href, link.newWindow)
      }
      {...rest}
    >
      {link.label}
    </Button>
  ));
};
